<template>
    <validation-provider :rules="rules" :name="name" v-slot="{errors, required}">
        <v-textarea v-bind="$attrs" v-on="$listeners" :error-messages="errors"
        :color="color">
            <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
            <template v-for="(_, name) of $scopedSlots" v-slot:[name]="scope">
                <slot :name="name" v-bind="scope"/>
            </template>

            <template #label v-if="label && !$scopedSlots[label]">
                <div :class="[errors.length==0 ? `${color}--text` : '']">
                    {{getLabel(required)}}
                </div>
            </template>
        </v-textarea>
    </validation-provider>
</template>
<script>
export default {
    name:"Textarea",
    props:{
        rules: {
            type: [Object, String],
            default: ""
        },
        label: {
            type: String
        },
        color:{
            type: String,
            default: "primary"
        },
        name:{
            type: String,
        }
    },
    methods:{
        getLabel(required){
            if(this.label){
                if (required){
                    return this.label + " *";
                }
                return this.label;
            }
            return undefined;
        }
    }
}
</script>